import React, { useEffect, useState } from 'react'
import "./styles/SearchBar.css"

import dict from './dictionary'

const SearchBar = () => {
    
    const [query, setQuery] = useState("")
    const [results, setResults] = useState([])

    function handleSearch(e) {
        setQuery(e.target.value)
    }

    useEffect(() => {
        const keywords = query.toLowerCase().split(" ")

        let pageValues = {}

        for (let keyword of keywords) {
            let pages = keyword in dict ? dict[keyword] : []
            
            for (let page of pages) {
                if (page in pageValues) {
                    pageValues[page] += 1
                } else {
                    pageValues[page] = 1
                }
            }
        }

        let sortedPageValues = Object.keys(pageValues).map(
            (key) => { return [key, pageValues[key]] }
        )

        sortedPageValues.sort((first, second) => {
            return second[1] - first[1]
        })

        let res = sortedPageValues.map((e) => { return e[0] })

        setResults(res)
    }, [query])

    return (
        <div className="search-bar">
            <div style={{marginRight: "2vh"}}>
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.29785 8.29834L21.4996 21.5001" stroke="var(--text-primary)" stroke-width="3"/>
                    <circle cx="8.29825" cy="8.29825" r="8.29825" fill="var(--text-primary)"/>
                    <circle cx="8.29778" cy="8.29827" r="6.03509" fill="var(--background)"/>
                </svg>
            </div>
            <div className="searches">
                <input
                    className="searchbar-input"
                    value={query}
                    onChange={e => handleSearch(e)}
                    type="text"
                    placeholder="Search"
                />
                <div className="options">
                    {results.map((item, index, arr) => {
                        return (
                            <div key={index} className={arr.length === 1 ? "firstAndLast" : index === arr.length - 1 ? "lastResult" : index === 0 ? "firstResult" : "result"}>
                                <button onClick={() => {window.location.href= item !== "Home" ? "/waterloo/" + item.toLowerCase().replaceAll(" ", "-") : "/waterloo"}} className='optionButton'>{item}</button>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default SearchBar